import { render, staticRenderFns } from "./user-group-detail-modal.vue?vue&type=template&id=66cc01bd&"
import script from "./user-group-detail-modal.vue?vue&type=script&lang=js&"
export * from "./user-group-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports